import { useEffect, useState } from 'react'

import { mixOther } from 'api/mixOther'


type Item = {
  id: string;
  question: string;
  aswer: string;
};

type Home = {
  meta_title: string;
  meta_description: string;
  meta_keywords: string;
   list_QA: Item[];
};

const faqData = [
    {
        id: "payment",
        title: "Quy định về thanh toán",
        content: (
            <>
                <p>Có 2 phương thức thanh toán sau:</p>
                <ul>
                    <li>Thanh toán tiền mặt khi nhận hàng (COD).</li>
                    <li>Thanh toán chuyển khoản.</li>
                </ul>
                <p>Quy định về nhận lại phần chênh lệch chuyển khoản:</p>
                <ul>
                    <li>Khi khách hàng thanh toán bằng phương thức chuyển khoản.</li>
                    <li>Áp dụng trong trường hợp thuocsi.vn không giao đủ số lượng sản phẩm đã đặt.</li>
                    <li>Đối với các đơn hàng không giao đủ số lượng sản phẩm, hệ thống sẽ tự động chuyển lại phần chênh lệch với điều kiện đã cập nhật thông tin thanh toán.</li>
                </ul>
                <a className="text-[var(--primary-color)]" href="#">
                    Xem thêm câu hỏi về thanh toán
                </a>
            </>
        ),
    },
    {
        id: "tracking",
        title: "Theo dõi đơn hàng",
        content: (
            <>
                <p>Có 2 phương thức để theo dõi đơn hàng:</p>
                <ul>
                    <li>Truy cập vào mục "Đơn hàng của tôi" để theo dõi trạng thái đơn hàng.</li>
                    <li>Nhấp vào từng đơn hàng để theo dõi trạng thái.</li>
                </ul>
                <a className="text-[var(--primary-color)]" href="#">
                    Xem thêm câu hỏi về vận chuyển
                </a>
            </>
        ),
    },
    {
        id: "return",
        title: "Chính sách trả hàng",
        content: (
            <>
                <ul>
                    <li>Khách hàng có thể gửi yêu cầu trả hàng trong vòng 05 ngày kể từ lúc đơn hàng được giao hàng thành công.</li>
                    <li>Đối với các sản phẩm đông lạnh, khách hàng cần gửi yêu cầu trả trong vòng 24 giờ kể từ lúc đơn hàng được giao thành công.</li>
                    <li>Đối với các sản phẩm trả hàng liên quan đến chất lượng thì thời hạn yêu cầu trả trong vòng 30 ngày kể từ lúc đơn hàng được giao thành công.</li>
                </ul>
                <a className="text-[var(--primary-color)]" href="#">
                    Xem thêm câu hỏi về thanh toán
                </a>
            </>
        ),
    },
];

export default function CauHoi() {
    const [openId, setOpenId] = useState<string | null>(null);

    const toggle = (id: string) => {
        setOpenId((prev) => (prev === id ? null : id));
    };

    const [home, setHome] = useState<Home | null>(null)
        
    useEffect(() => {
        const loadOther = async () => {
            const res = await mixOther("sshome","vi")
                if (!res?.status || !res.data?.json) {
                return;
            }

            try {
                const parsed = JSON.parse(res.data.json);
                setHome((prev) => ({ ...prev, ...parsed }));
            } catch (error) {
                console.error("Failed to parse setting JSON:", error);
            }
        };

        loadOther();
    }, [])

    // useEffect(()=> {
    //     console.log(home)
    // },[home])

    return (
        <div className="!mt-8 mb-8">
            <div className="MuiContainer-root jss191 MuiContainer-maxWidthLg md:!pl-0 md:!pr-0">

                {/* Title */}
                <div className="styles_companyIntroduction__h04I7">
                    <div className="styles_title__JlrYL">
                        <div className="styles_companyTitle__W3WKs">
                            Các câu hỏi thường gặp
                        </div>
                        <svg
                            className="styles_vector__ifrV4"
                            width="202"
                            viewBox="0 0 200 4"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M0 2H200"
                                stroke="#005C29"
                                strokeWidth="4"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>
                </div>

                {/* Accordion List */}
                <div className="jss178">
                    { (home?.list_QA?.length ?? 0) > 0 && home?.list_QA.map((item) => {
                        const isOpen = openId === item.id;
                        return (
                            <div
                                key={item.id}
                                className="MuiPaper-root MuiAccordion-root MuiPaper-elevation0 !border-b !border-gray-200"
                            >
                                {/* Header */}
                                <button
                                    onClick={() => toggle(item.id)}
                                    aria-expanded={isOpen}
                                    aria-controls={`${item.id}-content`}
                                    id={`${item.id}-header`}
                                    className={`MuiButtonBase-root MuiAccordionSummary-root w-full flex justify-between items-center py-4 px-2 text-left hover:!text-[var(--primary-color)] ${isOpen ? "text-[var(--primary-color)]" : ""}`}
                                >
                                    <p className="MuiTypography-root MuiTypography-body1 font-medium text-[20px]">
                                        {item.question}
                                    </p>
                                    <svg
                                        className={`MuiSvgIcon-root transition-transform duration-300 ${isOpen ? "!rotate-180" : ""}`}
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                        width="24"
                                        height="24"
                                    >
                                        <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
                                    </svg>
                                </button>

                                {/* Content */}
                                {isOpen && (
                                    <div
                                        className="MuiAccordionDetails-root px-4 pb-4 text-[16px]"
                                        id={`${item.id}-content`}
                                        role="region"
                                        aria-labelledby={`${item.id}-header`}
                                    >
                                        <span dangerouslySetInnerHTML={{ __html: item.aswer || ''}}></span>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>

            </div>
        </div>
    );
}